import CardComponent from "./CardComponent";

export class LabelRow extends CardComponent {

}
